export default "__VITE_ASSET__DvNRdyFe__"